import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../environments/environment';
import {IWallet, Wallet} from '../models/wallet.model';
@Injectable({
  providedIn: 'root'
})
export class WalletService {

  constructor(private http: HttpClient) { }

  getWallet(): Observable<any> {
    return this.http.get<any>(`${environment.url}/wallet`);
  }

  query(page: number, size: number): Observable<any> {
    return this.http.get<any>(`${environment.url}/wallet` + (size ? '?page=' + page + '&size=' + size : ''));
  }

  getWalletBycurrentSearch(search: string, page: number, size: number) {
    return this.http.get<any>(`${environment.url}/wallet` + ('/_search?search=name:' + search + '&page=' + page + '&size=' + size));
  }

  saveWallet(wallet: IWallet) {
    return this.http.post<any>(`${environment.url}/wallet`, wallet);
  }

  saveWalletKahpoo() {
    return this.http.post<any>(`${environment.url}/wallet/kahpoo`, null);
  }

  getIdWalletAllTransactions(idA: number) {
    return this.http.get<any>(`${environment.url}/wallet/all_transaction/` + idA);
  }

  // api/transaction/retrieveForWalletCustomerKahpooShop
  // Retourne toutes les transactions associées au wallet client de la boutique officielle KAHPOO.
  getAllKahpooWalletCustomerTransactions_v1() {
    return this.http.get<any>(`${environment.url}/transaction/retrieveForWalletCustomerKahpooShop`);
  }

  // api/transaction/retrieveForWalletSellerKahpooShop
  // Retourne toutes les transactions associées au wallet vendeur de la boutique officielle KAHPOO.
  getAllKahpooWalletSellerTransactions_v1() {
    return this.http.get<any>(`${environment.url}/transaction/retrieveForWalletSellerKahpooShop`);
  }

  // api/transaction/retrieveForWalletTiers
  // Retourne toutes les transactions associées au wallet tiers.
  // L'identifiant du wallet est passé en paramètre dans le corps de la requête
  getAllWalletTiersTransactions_v1(idWallet: number) {
    return this.http.post<any>(`${environment.url}/transaction/retrieveForWalletTiers` ,idWallet);
  }

  // api/transaction/retrieveForWallet
  // Retourne toutes les transactions associées à un wallet.
  // L'identifiant du wallet est passé en paramètre dans le corps de la requête
  getAllWalletTransactions_v1(idWallet: number) {
    return this.http.get<any>(`${environment.url}/transaction/retrieveForWallet/` + idWallet);
  }

  getidWallet(idA: number) {
    return this.http.get(`${environment.url}/wallet/` + idA);
  }

  getUSerWallet(idA: number) {
    return this.http.get(`${environment.url}/wallet/user/` + idA);
  }

  getWalletKahpoo() {
    return this.http.get(`${environment.url}/v1/wallet/kahpoo`);
  }

  getWalletKahpooTransaction() {
    return this.http.get(`${environment.url}/v1/wallet/kahpoo/transactions`);
  }

  //api/v1/wallet/tiers/transactions
  getWalletKahpooTransaction_v1_old() {
    return this.http.get(`${environment.url}/v1/wallet/tiers/transactions`);
  }

  // allPosts(page: number, size: number): Observable<any>{
  //   return this.http.get(`${environment.url}/v1/post/all?fields=postProducts,postServiceModels,postSubProducts&page=${page}&size=${size}`);
  // }

  // https://www.kahpoo.com/api/transaction/retrieveForWalletTiers.
  getWalletKahpooTransaction_v1(page: number, size: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post(`${environment.url}/transaction/retrieveForWalletTiers?page=${page}&size=${size}`, null, { headers: headers });
  }

  retrieveTransactionsForWalletTiers(
    sessionId: string,
    page: number = 0,
    size: number = 10,
    sortBy: string = 'date',
    sortOrder: string = 'DESC',
    dateDebut: string = '',
    dateFin: string = ''
  ): Observable<any> {
    const headers = new HttpHeaders({
      'kapo_session_id': sessionId,
    });

    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sortBy', sortBy)
      .set('sortOrder', sortOrder)
      .set('dateDebut', dateDebut)
      .set('dateFin', dateFin);

    return this.http.get<any>(`${environment.url}/retrieveForWalletTiers`, { headers, params });
  }

  updateWallet(wallet: IWallet) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/wallet/` + wallet.id, wallet, {headers: headers});
  }

  deleteWallet(idA: number) {
    return this.http.delete(`${environment.url}/wallet/` + idA);
  }
}
